import {Component, Input} from '@angular/core';
import {G2Product} from '../../../models/g2-review.model';
import {WriteReviewComponent} from '../write-review/write-review.component';
import {TranslatePipe} from '@spartacus/core';

@Component({
  selector: 'dcp-first-review',
  templateUrl: './first-review.component.html',
  styleUrls: ['./first-review.component.scss'],
  imports: [WriteReviewComponent, TranslatePipe],
})
export class FirstReviewComponent {
  @Input() infoText: string;
  @Input() btnText: string;
  @Input() g2Product: G2Product;
  @Input() pageCount: number;
}
